var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
function ComponentSelect(_a) {
    var { title = null, defaultValue = null, options, classes = null, onChange, noneSelectedTitle = null, testId = null } = _a, props = __rest(_a, ["title", "defaultValue", "options", "classes", "onChange", "noneSelectedTitle", "testId"]);
    const [selected, setSelected] = useState(defaultValue !== null && defaultValue !== void 0 ? defaultValue : '_empty');
    useEffect(() => {
        if (defaultValue) {
            onChange(defaultValue);
            setSelected(defaultValue);
        }
    }, [defaultValue]);
    return (_jsxs("select", Object.assign({}, props, { "data-testid": testId, className: classes, value: selected, onChange: (event) => {
            setSelected(event.target.value);
            onChange(event.target.value);
        } }, { children: [title && _jsx("option", Object.assign({ disabled: true, value: '_empty' }, { children: title })), noneSelectedTitle != null && (_jsx("option", Object.assign({ value: '_none' }, { children: noneSelectedTitle }))), Object.entries(options).map(([key, value]) => (_jsx("option", Object.assign({ value: key }, { children: value }), key)))] })));
}
ComponentSelect.propTypes = {
    title: PropTypes.string,
    options: PropTypes.objectOf(PropTypes.shape).isRequired,
    classes: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    noneSelectedTitle: PropTypes.string,
    defaultValue: PropTypes.string
};
export default ComponentSelect;
